import { serviceAgreementApi } from 'api';
import { type GetServiceAgreementListResponse } from 'pco-product-service-internal-consumer';

export const getAllServiceAgreementsApi = async (
  partnerUid?: string,
  businessRelationUid?: string,
  accountNumber?: string,
): Promise<GetServiceAgreementListResponse> => {
  return await serviceAgreementApi.getServiceAgreementList({
    getServiceAgreementListRequest: { partnerUid, businessRelationUid, accountNumber },
  });
};
